export enum PaymentRadioValues {
  CreditCard = 'credit-card',
  ACH = 'ach'
}

export const FORMATTED_PAYMENT_METHODS = {
  [PaymentRadioValues.CreditCard]: 'Credit Card',
  [PaymentRadioValues.ACH]: 'E-Check'
}
